import { render, staticRenderFns } from "./PerguntaExtra.vue?vue&type=template&id=325caed9&scoped=true&"
import script from "./PerguntaExtra.vue?vue&type=script&lang=js&"
export * from "./PerguntaExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325caed9",
  null
  
)

export default component.exports